import React from 'react'
import Button from './Button'
import Container from './Container'


const Contact = () => {
	return <div className="Contact Section" id="contact">
		<Container>

			<h2>Связь с нами</h2>
			<p>Если Вы хотите связаться с нами, Вы можете написать нам на почту:</p>
			<p><Button class="equal" link="mailto:gamedevcommand@mail.ru" newtab>Email</Button></p>
			<p>Можно также отправить сообщение нашему телеграм боту:</p>
			<p><Button class="equal" link="https://t.me/altycoon_bot" newtab>Telegram</Button></p>

			<div className="hahahaah"></div>
		</Container>
	</div>
}

export default Contact